// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.active[data-v-5d8bb964] {\n  font-weight: bold;\n  background: #e0e0e0;\n  color: #000 !important;\n}\n", ""]);
// Exports
module.exports = exports;
